import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { PATH } from '../app.api'

@Injectable()
export class TermsService {
	constructor(private http: HttpClient) {}

	public updateTermUserApp() {
		const options: HttpHeaders = this.setHeader()

		return this.http.patch<any>(
			`${PATH}/app/user/term`,
			{ headers: options }
		).pipe(
			map(result => {
				return result.content
			})
		)
	}
		private setHeader(): HttpHeaders {
		return new HttpHeaders({ 'Content-Type': 'application/json' }).append( 'x-source-from', 'PAINEL')
	}
}
